import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of as observableOf } from 'rxjs';
import { PlanStep } from './PlanStep';
import { PlanCoordinate } from './plan-coordinate';


@Injectable()
export class PlanCoordinateResolve implements Resolve<PlanCoordinate> {
  constructor() { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PlanCoordinate> {
    // const strategyId = Number.parseInt(route.paramMap.get('strategyId'));
    // TODO retrieve the last saved step for the user
    return observableOf(PlanCoordinate.stepBy(PlanStep.DETERMINE_CURRENT_REALITY));
  }
}
